import { autorun } from 'mobx';
import { observer } from 'mobx-react';
import { applySnapshot, getSnapshot } from 'mobx-state-tree';
import * as React from 'react';
import { clientVersion } from '../main/clientVersion_tmp';
import { transl } from '../main/transl';
import { mg } from '../mg/mg';
import { toasterSvc } from '../services/ToasterSvc';
import { useOmnistore } from '../stores/Omnistore';

export const ReoctoLifecycle = observer((props: {}) => {
	const KEY = 'tester';
	const reoctoStore = useOmnistore().reoctoStore;
	React.useEffect(() => {
		try {
			const o = mg.storage.get(KEY, {});
			o.isOffline = false;
			o.showTesterDialog = false;
			applySnapshot(reoctoStore, o);
			toasterSvc.info('clientVersion', {message: transl('welcomeToReocto', clientVersion.replace(/-.*/, ''))});
		} catch (e) {
			console.warn('reoctoStore', e);
		}
		return autorun(() => mg.storage.put(KEY, getSnapshot(reoctoStore)));
	}, []);
	return null;
});
